import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Country } from 'src/app/models/country';
import { getWebsiteMainAnalyticsActions } from 'src/app/shared/store/_features/website/analytics/website-analytics.actions';
import {
  isWebsiteAggregateAnalyticsLoaded,
  selectWebsiteAggregateAnalytics,
} from './../../../../../../shared/store/_features/website/analytics/website-analytics.selector';
import { UserWebsite, WebsiteModel } from '../../../portal.model';
import { selectWebsite } from 'src/app/shared/store/_features/website/website.selector';
import { ApexOptions } from 'ng-apexcharts';

@Component({
  selector: 'app-website-aggregate-analytics-bar',
  templateUrl: './website-aggregate-analytics-bar.component.html',
  styleUrls: ['./website-aggregate-analytics-bar.component.css'],
})
export class WebsiteAggregateAnalyticsBarComponent implements OnInit {
  loaded: boolean = false;
  website: WebsiteModel;
  analytics: {
    bestCountry: { country: string; countryItem: Country; visitors: number };
    bounce_rate: any;
    pageviews: any;
    visit_duration: any;
    visitors: any;
    visits: any;
    realtimeVisitors: number;
    timeSeries: any[];
  };

  sparklineOptions: ApexOptions;

  constructor(private store: Store) {
    this.store.select(selectWebsite).subscribe((website) => {
      this.website = website;
    });

    this.store
      .select(selectWebsiteAggregateAnalytics)
      .subscribe((analytics) => {
        this.analytics = analytics;
        if (analytics?.timeSeries) {
          this.prepareSparkline();
        }
      });

    this.store.select(isWebsiteAggregateAnalyticsLoaded).subscribe((loaded) => {
      this.loaded = loaded;
    });
  }

  ngOnInit() {}

  prepareSparkline() {
    if (!this.analytics?.timeSeries?.length) return;

    const timeSeries = [...this.analytics.timeSeries];

    // Extreme compression for the head sparkline
    // Target ~12-15 points to keep it super minimalistic and "squash" zeros
    const targetPoints = 12;
    const originalCount = timeSeries.length;
    const compressionFactor = Math.ceil(originalCount / targetPoints);

    let sparkSeries: number[] = [];
    let sparkLabels: string[] = [];

    if (compressionFactor > 1) {
      for (let i = 0; i < originalCount; i += compressionFactor) {
        const window = timeSeries.slice(
          i,
          Math.min(i + compressionFactor, originalCount),
        );
        const avgVisitors =
          window.reduce((sum, item) => sum + item.visitors, 0) / window.length;
        sparkSeries.push(Math.round(avgVisitors));

        // Use the middle date of the window for label accuracy
        const labelItem = window[Math.floor(window.length / 2)] || window[0];
        const date = new Date(labelItem.date);
        sparkLabels.push(
          date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }),
        );
      }
    } else {
      sparkSeries = timeSeries.map((item) => item.visitors);
      sparkLabels = timeSeries.map((item) => {
        const date = new Date(item.date);
        return date.toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric',
        });
      });
    }

    this.sparklineOptions = {
      series: [
        {
          name: 'Visitors',
          data: sparkSeries,
        },
      ],
      xaxis: {
        categories: sparkLabels,
      },
      chart: {
        type: 'area',
        height: 120,
        sparkline: {
          enabled: true,
        },
        animations: {
          enabled: true,
          easing: 'easeinout',
          speed: 800,
        },
      },
      stroke: {
        curve: 'smooth',
        width: 1.5, // Even thinner for elegance
      },
      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.3,
          opacityTo: 0,
          stops: [0, 90, 100],
        },
      },
      colors: ['#ffffff'], // Pure white for sophisticated blend
      tooltip: {
        theme: 'dark',
        fixed: {
          enabled: false,
        },
        x: {
          show: true,
        },
        y: {
          title: {
            formatter: () => 'Avg. Visitors',
          },
        },
        marker: {
          show: false,
        },
      },
    };
  }
}
